<template>
  <el-dialog
    title="提示"
    :visible.sync="show"
    width="50%"
    :before-close="handleClose">
    <div class="title">
      确认修改所选<span>{{ selectList.length }}</span>家影院的折扣？
    </div>
    <div class="table">
      <div class="table-list">
        <el-table
          :data="selectList"
          style="width: 100%"
          :header-cell-style="bgColor"
          >
<!--          <el-table-column-->
<!--            label="序号"-->
<!--            width="180"-->
<!--            align="center">-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{ row.id }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
<!--          <el-table-column-->
<!--            label="省份"-->
<!--            width="180"-->
<!--            align="center">-->
<!--            <template slot-scope="{row}">-->
<!--              <span>{{ row.id }}</span>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            label="城市"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.cityName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="影院名称"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.cinemaName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="当前折扣（%）"
            align="center">
            <template slot-scope="{row}">
              <span>{{ row.discount }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            label="修改后的折扣（%）"
            align="center">
            <template slot-scope="{row}">
              <span v-if="discountBatch!='' && diffDiscount == ''">{{discountBatch }}%</span>
              <span v-if="discountBatch == ''">{{ type == 1?row.discount + diffDiscount: row.discount  - diffDiscount}}%</span>
              <span v-if="discountBatch !='' && diffDiscount!=''">{{ type == 1?Number(discountBatch) + Number(diffDiscount): Number(discountBatch)  - Number(diffDiscount)}}%</span>
            </template>
          </el-table-column>
        </el-table>
<!--        <el-pagination-->
<!--          v-if="selectList.length > 0"-->
<!--          background-->
<!--          class="align-right"-->
<!--          @size-change="handleSizeChange"-->
<!--          @current-change="handleCurrentChange"-->
<!--          :current-page="currentPage"-->
<!--          :page-sizes="[10, 20, 30, 40]"-->
<!--          :page-size="10"-->
<!--          layout="total, sizes, prev, pager, next, jumper"-->
<!--          :total="selectList.length">-->
<!--        </el-pagination>-->
        <div class="button">
          <div class="button-cancel" @click="closeShow">取消</div>
          <div class="button-confirm" @click="confirm()">确定</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { saasOrder} from "../../../../../javaApi/saasOrder";
const SaasM = new saasOrder()
export default {
name: "modifyDiscount",
  props:['show','selectList','discountBatch','diffDiscount','type'],
  data(){
  return{
    dialogVisible:false,
    list:[],
    bgColor:{
      background: '#FCFAF8'
    },
    searchForm:{
      pageSize:'',
      pageNo:''
    },
    currentPage:1,
    ids:[]
  }
  },

  methods:{
    handleClose(){
      this.$parent.show = false
    },
    pageChange(){

    },
    closeShow(){
      this.$parent.show = false
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.searchForm.pageSize = val
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.searchForm.pageNo = val
    },
    // 确定修改
    confirm(){
      let params;
      let arr = []
      for(let index in this.selectList){
        arr.push(this.selectList[index].id)
      }
      this.ids = arr
      params = {
        ids:this.ids,
        discount:this.discountBatch,
        type:this.type,
        diffDiscount:this.diffDiscount
      }
      SaasM.updateDiscountBatch(params).then(res=>{
        if(res.data.code == 200){
          this.dialogVisible = false
          this.$Message.success('修改成功')
          this.$parent.discountBatch = ''
          this.$parent.diffDiscount = ''
          this.closeShow()
          this.$parent.dialogVisible = false
          this.$parent.getList()
        }else{
          this.$Message.error(res.data.info || res.data.message)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.title{
  font-size: 16px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #222222;
  line-height: 22px;
  span{
    color: #FF4F76;
  }
}
.button{
  display: flex;
  align-items: center;
  justify-content: center;
  //position: fixed;
  //width: 50%;
  //padding-bottom: 20px;
  //background: #fff;
  //left: 0;
  //right: 0;
  //margin: auto;
  margin-top: 23px;

  .button-cancel{
    width: 76px;
    height: 32px;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 32px;
    margin:0 10px;
    cursor: pointer;
  }
  .button-confirm{
    width: 104px;
    height: 32px;
    background: #FF8622;
    border-radius: 2px;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #ffffff;
    line-height: 32px;
    margin: 0 10px;
    cursor: pointer;
  }
}
.table{
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/SaasJoin/moviePriceList/components/modifyDiscount.vue